import { EUiStates } from "@constants/enum";
import { ElementType, ReactElement } from "react";
import { Button, ButtonToolbar, Modal } from "reactstrap";

interface IModalConfirmation {
  title: string;
  icon: string | ElementType;
  body: string;
  modalStatus: boolean;
  handleModalStatus: () => void;
  handleConfirm: () => void;
  modalType: EUiStates.WARNING | EUiStates.DANGER | EUiStates.SUCCESS;
}

const ModalConfirmation = ({
  title,
  icon: IconComponent,
  body,
  modalStatus,
  handleModalStatus,
  handleConfirm,
  modalType,
}: IModalConfirmation): ReactElement => (
  <Modal isOpen={modalStatus} className={`modal-dialog--${modalType}`}>
    <div className="modal__header">
      <button
        className="lnr lnr-cross modal__close-btn"
        aria-label="modal__close-btn"
        type="button"
        onClick={handleModalStatus}
      />
      <h4 className="text-modal modal__title">
        {typeof IconComponent === "string" ? (
          <span className={`lnr lnr-${IconComponent} modal__title-icon`} />
        ) : (
          <IconComponent className="modal__title-icon" />
        )}
        {title}
      </h4>
    </div>
    <div className="modal__body">{body}</div>
    <ButtonToolbar className="modal__footer">
      <Button onClick={handleModalStatus}>Cancel</Button>{" "}
      <Button color={modalType} onClick={handleConfirm}>
        Ok
      </Button>
    </ButtonToolbar>
  </Modal>
);

export default ModalConfirmation;
